export default __webpack_public_path__ + "static/media/HV B2B Banner carpet.28f53c9b.jpg";